export const LoaderInfoOverlay = (text, title = '') => {
  try {
    document.getElementById('loader-text').innerHTML = text
    document.getElementById('loader').classList.add('show')
    document.getElementById('loader').classList.add('overlay-full-page')
    document.getElementById('loader').classList.remove('hide')
  } catch (error) {
    console.log('Erro ao carregar o load')
  }
}

export const CloseLoaderInfoOverlay = () => {
  try {
    document.getElementById('loader-text').innerHTML = ''
    document.getElementById('loader').classList.add('hide')
    document.getElementById('loader').classList.remove('show')
    document.getElementById('loader').classList.remove('overlay-full-page')
  } catch (error) {
    console.log('Erro ao carregar o load')
  }
}
